import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { LinkContext } from "../../LinkProvider";
import heroDesktop from "../../img/AboutUs/Herodesktop.webp";
import heroMobile from "../../img/AboutUs/Heromob.webp";
import Fade from 'react-reveal/Fade';

function Banner() {
  const { link } = useContext(LinkContext);
  const { t } = useTranslation();

  return (
    <Fade bottom>
    <section className="pt-[60px] xl:pt-[122px]">
      {/* Desktop */}
      <div className="hidden xl:block">
        <div className="relative mx-auto h-[520px] max-w-[1220px] overflow-hidden">
          <img
            src={heroDesktop}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute left-[45px] top-[60px] z-10 w-[471px]">
            <h1 className="font-['Nunito_Sans'] text-[48px] font-black leading-[1.5] text-[#3273b4]">
              {t("about.banner.title1")}
            </h1>
            <h2 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273b4]">
              {t("about.banner.title2")}
            </h2>
            <span className="block h-[4px] w-[193px] bg-[#05193a]" />
            <p className="mt-[20px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("about.banner.text1")}
            </p>
            <p className="mt-[15px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("about.banner.text2")}
            </p>
            <a
              href={link}
              className="mt-[40px] inline-flex h-[42px] items-center justify-center rounded-[10px] bg-[#05193a] px-[35px] font-[Inter] text-[16px] font-light capitalize text-white transition-colors hover:bg-[#0d2c60]"
            >
              {t("header.openAccount")}
            </a>
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div className="xl:hidden">
        <div className="relative h-[518px] w-full overflow-hidden">
          <img
            src={heroMobile}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-x-0 top-[47px] z-10 text-center">
            <h1 className="font-['Nunito_Sans'] text-[34px] font-black leading-[1.5] text-[#3273b4]">
              {t("about.banner.title1")}
            </h1>
            <h2 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273b4]">
              {t("about.banner.title2")}
            </h2>
          </div>
          <div className="absolute inset-x-0 top-[188px] z-10 flex justify-center">
            <a
              href={link}
              className="inline-flex h-[38px] items-center justify-center rounded-[10px] bg-[#05193a] px-[28px] font-[Inter] text-[14px] font-light capitalize text-white transition-colors hover:bg-[#0d2c60]"
            >
              {t("header.openAccount")}
            </a>
          </div>
        </div>
        <div className="px-[20px] pt-[80px]">
          <p className="font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
            {t("about.banner.text1")}
          </p>
          <p className="mt-[15px] font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
            {t("about.banner.text2")}
          </p>
          <a
            href={link}
            className="mt-[34px] inline-flex h-[38px] items-center justify-center rounded-[10px] bg-[#05193a] px-[28px] font-[Inter] text-[14px] font-light capitalize text-white transition-colors hover:bg-[#0d2c60]"
          >
            {t("header.openAccount")}
          </a>
        </div>
      </div>
    </section>
    </Fade>
  );
}

export default Banner;
